import { render, staticRenderFns } from "./CoursePaymentModal.vue?vue&type=template&id=23cb350b&"
import script from "./CoursePaymentModal.vue?vue&type=script&lang=js&"
export * from "./CoursePaymentModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports